<template>
    <card-component title="Historial de Acciones" icon="account-multiple" class="has-table has-mobile-sort-spaced">
      <card-toolbar slot="toolbar">
          <div slot="left" class="buttons has-addons">
            <b-field grouped group-multiline>
            <label class="label customlabel">Fechas</label>
              <b-datepicker
                class="customdatepicker"
                v-model="dates"
                v-on:input="resetPageAndLoad"
                :max-date="maxDate"
                range>
              </b-datepicker>
            </b-field>
          </div>

          <div slot="right" class="buttons has-addons" v-if="tableConfiguration.data.length > 0">
            <b-field horizontal>
              <a v-bind:href="urlDownloadCSV()" download="template-csv">
                <b-button class="button-secondary" v-on:click="showToast('Descargando Historial','is-info')">
                  <b-icon icon="download" custom-size="default" type="is-info"/>
                </b-button>
              </a>
            </b-field>
          </div>
        </card-toolbar>
      <historical-table v-bind="tableConfiguration" @page-change="handlePageChange" />
    </card-component>
</template>

<style>
  .customlabel {
    padding-top: 6px;
    padding-left: 1.2rem;
  }
  .customdatepicker {
    width: 14.75em;
    margin-left: 1rem;
  }
</style>

<script>
import HistoricalTable from '@/components/historical/HistoricalTable'
import CardComponent from '@/components/CardComponent'
import HistoricalResponsesRepository from '@/services/HistoricalResponsesRepository'
import CardToolbar from '@/components/CardToolbar'

export default {
  name: 'HistoricalCardTable',
  components: {
    CardComponent,
    HistoricalTable,
    CardToolbar
  },
  data () {
    return {
      allDataHistorical: [],
      tableConfiguration: {
        isLoading: false,
        paginated: true,
        perPage: 100,
        currentPage: 1,
        total: 0,
        data: []
      },
      fields: ['dni', 'external_id', 'date', 'status'],
      dates: [],
      maxDate: new Date()
    }
  },
  mounted () {
    this.maxDate.setDate(new Date().getDate() + 1)
    var dateOffset = (24 * 60 * 60 * 1000) * 7
    var myDate = new Date()
    myDate.setTime(myDate.getTime() - dateOffset)
    this.dates = [myDate, this.maxDate]
    this.loadHistoricalResponses()
  },
  methods: {
    loadHistoricalResponses () {
      this.tableConfiguration.isLoading = true
      HistoricalResponsesRepository.getHistorialResponses(
        this.getParams()
      ).then((r) => {
        this.tableConfiguration.isLoading = false
        if (r.data) {
          this.tableConfiguration.data = r.data.results
          let currentTotal = r.data.count
          if (r.data.count / this.tableConfiguration.perPage > 1000) {
            currentTotal = this.tableConfiguration.perPage * 1000
          }
          this.tableConfiguration.total = currentTotal
        }
      }).catch(e => {
        this.tableConfiguration.isLoading = false
        this.showToast('Error: ' + e.message, 'is-danger')
      })
    },
    getParams () {
      const params = {
        start_date: this.parseDate(this.dates[0]),
        end_date: this.parseDate(this.dates[1]),
        page: this.tableConfiguration.currentPage
      }
      return params
    },
    resetPageAndLoad () {
      this.tableConfiguration.currentPage = 1
      this.loadHistoricalResponses()
    },
    getParamsURL () {
      let params = '?'
      params = params.concat('start_date=' + this.parseDate(this.dates[0]) + '&')
      params = params.concat('end_date=' + this.parseDate(this.dates[1]))
      return params
    },
    handlePageChange (value) {
      this.tableConfiguration.currentPage = value
      this.loadHistoricalResponses()
    },
    showToast (message, type) {
      this.$buefy.toast.open({
        message: message,
        type: type
      })
    },
    urlDownloadCSV () {
      return HistoricalResponsesRepository.urlDownloadCSV(this.getParamsURL())
    },
    parseDate (date) {
      return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
    }
  }
}
</script>
